import { render, staticRenderFns } from "./OnlineMessages.vue?vue&type=template&id=50cfd118&scoped=true"
import script from "./OnlineMessages.vue?vue&type=script&lang=js"
export * from "./OnlineMessages.vue?vue&type=script&lang=js"
import style0 from "./OnlineMessages.vue?vue&type=style&index=0&id=50cfd118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfd118",
  null
  
)

export default component.exports